import React, { useState } from "react";
import "./about.css";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DmsBookingModal from "./dmsBookingModal";
import dmsAboutImage from "../../assets/dmsAboutImage.jpg";

const DmsAbout = () => {
  const [showDmsModal, setShowDmsModal] = useState(false);

  return (
    <>
      <section className="dms-about-section">
        <div
          className="dms-about-bg-shape dms-about-bg-one"
          aria-hidden="true"
        ></div>

        <div
          className="dms-about-bg-shape dms-about-bg-two"
          aria-hidden="true"
        ></div>

        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div
                className="dms-about-visual"
                data-aos="fade-right"
                data-aos-duration="900"
                data-aos-delay="100"
              >
                <div className="dms-about-image-card">
                  <div className="dms-about-image-glow"></div>

                  <img
                    src={dmsAboutImage}
                    alt="TechCognics DMS distribution management ecosystem"
                    className="dms-about-image"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-lg-6 col-md-12">
              <div
                className="dms-about-content"
                data-aos="fade-left"
                data-aos-duration="900"
                data-aos-delay="150"
              >
                <div className="dms-about-label">
                  WHY DISTRIBUTION NEEDS DMS
                </div>

                <h2>
                  Your Distribution Network
                  <br />
                  Should Not Run on{" "}
                  <span>Excel, WhatsApp & Manual Reports</span>
                </h2>

                <p className="dms-about-description">
                  Growing distribution businesses often struggle with
                  disconnected systems, delayed information and manual
                  processes. TechCognics DMS brings your distribution
                  operations together into one connected platform with a
                  real-time view of your business.
                </p>

                <div className="dms-about-points">
                  <div
                    className="dms-about-point"
                    data-aos="fade-left"
                    data-aos-duration="700"
                    data-aos-delay="250"
                  >
                    <span className="dms-about-check">✓</span>
                    <span>Limited visibility into distributor stock</span>
                  </div>

                  <div
                    className="dms-about-point"
                    data-aos="fade-left"
                    data-aos-duration="700"
                    data-aos-delay="300"
                  >
                    <span className="dms-about-check">✓</span>
                    <span>Delayed secondary sales data</span>
                  </div>

                  <div
                    className="dms-about-point"
                    data-aos="fade-left"
                    data-aos-duration="700"
                    data-aos-delay="350"
                  >
                    <span className="dms-about-check">✓</span>
                    <span>Manual order collection and processing</span>
                  </div>

                  <div
                    className="dms-about-point"
                    data-aos="fade-left"
                    data-aos-duration="700"
                    data-aos-delay="350"
                  >
                    <span className="dms-about-check">✓</span>
                    <span>Distributor-wise sales reporting</span>
                  </div>

                  <div
                    className="dms-about-point"
                    data-aos="fade-left"
                    data-aos-duration="700"
                    data-aos-delay="400"
                  >
                    <span className="dms-about-check">✓</span>
                    <span>Stock-outs and excess inventory</span>
                  </div>

                  <div
                    className="dms-about-point"
                    data-aos="fade-left"
                    data-aos-duration="700"
                    data-aos-delay="450"
                  >
                    <span className="dms-about-check">✓</span>
                    <span>Delayed claims and manual reconciliation</span>
                  </div>

                  <div
                    className="dms-about-point"
                    data-aos="fade-left"
                    data-aos-duration="700"
                    data-aos-delay="450"
                  >
                    <span className="dms-about-check">✓</span>
                    <span>Multiple Excel files and disconnected systems</span>
                  </div>

                  <div
                    className="dms-about-point"
                    data-aos="fade-left"
                    data-aos-duration="700"
                    data-aos-delay="450"
                  >
                    <span className="dms-about-check">✓</span>
                    <span>Difficulty monitoring dealer and distributor performance</span>
                  </div>

                  <div
                    className="dms-about-point"
                    data-aos="fade-left"
                    data-aos-duration="700"
                    data-aos-delay="500"
                  >
                    <span className="dms-about-check">✓</span>
                    <span>
                      No single source of truth for sales and inventory
                    </span>
                  </div>
                </div>

                <button
                  type="button"
                  className="dms-about-btn"
                  data-aos="fade-up"
                  data-aos-duration="800"
                  data-aos-delay="550"
                  onClick={() => setShowDmsModal(true)}
                >
                  Request a Consultation

                  <span className="dms-about-btn-icon">
                    <ArrowForwardIcon fontSize="small" />
                  </span>
                </button>
              </div>
            </div>
          </div>

          <div
            className="dms-about-bottom"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay="650"
          >
            <span className="dms-about-bottom-line"></span>

            <p>
              One platform. One connected distribution network. One real-time
              view of your business.
            </p>

            <span className="dms-about-bottom-line"></span>
          </div>
        </div>
      </section>

      <DmsBookingModal
        show={showDmsModal}
        onClose={() => setShowDmsModal(false)}
      />
    </>
  );
};

export default DmsAbout;